"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var services_1 = require("../../../services");
var models_1 = require("../../../models");
var material_1 = require("@angular/material");
var timer_1 = require("rxjs/observable/timer");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var VcFooterComponent = /** @class */ (function () {
    function VcFooterComponent(webRTC, dialog, mediaDevicesService, vcService, renderer2) {
        this.webRTC = webRTC;
        this.dialog = dialog;
        this.mediaDevicesService = mediaDevicesService;
        this.vcService = vcService;
        this.renderer2 = renderer2;
        this.leave = new core_1.EventEmitter();
        this.isGavelDisabled = false;
        this.isHummerPunched = false;
        this.destroy$ = new Subject_1.Subject();
    }
    VcFooterComponent.prototype.ngOnInit = function () {
        this.subscribeToJudgeEvents();
    };
    VcFooterComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    VcFooterComponent.prototype.toggleAudio = function () {
        this.account.toggleAudio();
    };
    VcFooterComponent.prototype.toggleVideo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.account.toggleVideo();
                        return [4 /*yield*/, this.vcService.publish(this.account)];
                    case 1:
                        _b.sent();
                        this.vcService.clearMediaStream(this.mediaStream);
                        _a = this;
                        return [4 /*yield*/, this.vcService.requestMediaStream(this.account)];
                    case 2:
                        _a.mediaStream = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    VcFooterComponent.prototype.judgeHummerHitHandler = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.renderer2.setStyle(this.hummerIcon.nativeElement, 'pointer-events', 'none');
                        this.isGavelDisabled = true;
                        this.disableHummerIcon();
                        return [4 /*yield*/, this.webRTC.signal('Hint hummer', [], 'judgeHummerHitEvent')];
                    case 1:
                        _a.sent();
                        this.setHummerPunchedEffect();
                        return [2 /*return*/];
                }
            });
        });
    };
    VcFooterComponent.prototype.openLeaveDialog = function () {
        this.leave.emit();
    };
    VcFooterComponent.prototype.subscribeToJudgeEvents = function () {
        var _this = this;
        this.webRTC.on('signal:judgeHummerHitEvent', function (event) { return __awaiter(_this, void 0, void 0, function () {
            var hummerHint;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        hummerHint = new Audio('icons/gavel-hint.mp3');
                        return [4 /*yield*/, hummerHint.play()];
                    case 1:
                        _a.sent();
                        this.setHummerPunchedEffect();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    VcFooterComponent.prototype.setHummerPunchedEffect = function () {
        var _this = this;
        this.isHummerPunched = true;
        setTimeout(function () { return _this.isHummerPunched = false; }, 400);
    };
    VcFooterComponent.prototype.disableHummerIcon = function () {
        var _this = this;
        timer_1.timer(10000)
            .pipe(operators_1.takeUntil(this.destroy$))
            .subscribe(function () {
            _this.renderer2.setStyle(_this.hummerIcon.nativeElement, 'pointer-events', 'auto');
            _this.isGavelDisabled = false;
        });
    };
    __decorate([
        core_1.ViewChild('hummer_icon'),
        __metadata("design:type", core_1.ElementRef)
    ], VcFooterComponent.prototype, "hummerIcon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", models_1.LocalAccount)
    ], VcFooterComponent.prototype, "account", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], VcFooterComponent.prototype, "formattedRecordingDuration", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], VcFooterComponent.prototype, "leave", void 0);
    VcFooterComponent = __decorate([
        core_1.Component({
            selector: 'vc-footer',
            template: require('./vc-footer.component.html'),
            styles: [require('./vc-footer.component.css')],
            changeDetection: core_1.ChangeDetectionStrategy.OnPush
        }),
        __metadata("design:paramtypes", [services_1.WebRTCService,
            material_1.MatDialog,
            services_1.MediaDevicesService,
            services_1.VcService,
            core_1.Renderer2])
    ], VcFooterComponent);
    return VcFooterComponent;
}());
exports.VcFooterComponent = VcFooterComponent;
//# sourceMappingURL=vc-footer.component.js.map